import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { catchError, map, of } from 'rxjs';

import { AuthService } from '../../../services/auth.service';
import { AuthResource } from '../../../services/resources/auth.resource';
import { RouteService } from '../../../services/route.service';

@Component({
    selector: 'sl-no-server-connection',
    templateUrl: './no-server-connection.dialog.html',
    styleUrls: ['./no-server-connection.dialog.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NoServerConnectionDialog {
    isChecking = false;

    private readonly authResource = inject(AuthResource);
    private readonly authService = inject(AuthService);
    private readonly routeService = inject(RouteService);

    retryConnection(): void {
        this.isChecking = true;
        this.authResource
            .authCheck()
            .pipe(
                map(() => true),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 0) {
                        return of(false);
                    }

                    // connection is back, but user isn't logged in anymore
                    this.authService.logout();
                    return of(true);
                })
            )
            .subscribe(hasConnection => {
                this.isChecking = false;
                if (hasConnection) {
                    this.routeService.reloadPage();
                }
            });
    }
}
